module.exports = "/fonts/fa-brands-400.eot?4163c5ce45679952d5cb6dcf5d74a132";